// extracted by mini-css-extract-plugin
export default {"customButton":"phoneSMSVerification_customButton__GU4ZA","customInput":"phoneSMSVerification_customInput__mHWGm"};